
    import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
    import _ from 'lodash';
    import { mapState } from 'vuex';
    import { PlanItem } from '@/types/Reiseplan';
    import Planimpfung from '@/types/Planimpfung';
    import PatUntersuchung from '@/types/PatUntersuchung';
    import { DataTableHeaders } from '@/types';

    @Component({
        computed: {
            ...mapState('patient', ['loaders']),
        },
    })
    export default class OffenDatatable extends Vue {
        @Prop() impfungen!: Planimpfung[];
        @Prop() untersuchungen!: PatUntersuchung[];

        @PropSync('selected') selectedSynced!: PlanItem<Planimpfung | PatUntersuchung>[];

        public get headers(): DataTableHeaders<PlanItem<Planimpfung | PatUntersuchung>, 'plan_datum'> {
            return [
                { text: 'geplant', value: 'datumGeplant' },
                { text: 'Impfung / Untersuchung', value: 'bezeichnung' },
                { text: 'Plan', value: 'planDatum' },
            ];
        }

        public get items(): PlanItem<Planimpfung | PatUntersuchung>[] {
            return _.sortBy([
                ...this.impfungen.map(PlanItem.from),
                ...this.untersuchungen.map(PlanItem.from)
            ], ['datumGeplant', 'displayText']);
        }
    }
